import {
    SUPLIER_LIST_REQUEST,
    SUPLIER_LIST_SUCCESS,
    SUPLIER_LIST_FAIL
  } from '../constants/suplierConstants'

  
export const suplierListReducer = (state = {supliers : []}, action) => {

    switch (action.type) {
        case SUPLIER_LIST_REQUEST:
          return { loading: true, supliers: [] }
        case SUPLIER_LIST_SUCCESS:
          return {
            loading: false,
            supliers: action.payload.data

          }
        case SUPLIER_LIST_FAIL:
          return { loading: false, error: action.payload }
        default:
          return state
      }

}
